function collapsibleDetails() {
  if (window.innerWidth <= 767) {
    document.querySelectorAll('[data-information-title]').forEach(function(el) {
      if (!el.hasAttribute('data-toggle-added')) {
        el.addEventListener('click', toggleHandler);
        el.setAttribute('data-toggle-added', 'true');
      }
    });
  } else {
    document.querySelectorAll('[data-information-title]').forEach(function(el) {
      if (el.hasAttribute('data-toggle-added')) {
        el.removeEventListener('click', toggleHandler);
        el.removeAttribute('data-toggle-added');
      }
    });
  }
}

function toggleHandler(e) {
  const parent = e.currentTarget.closest('[data-information-item]');
  if (parent) {
    const textEl = parent.querySelector('[data-information-text]');
    if (textEl) {
      textEl.classList.toggle('active');
    }
  }
}

document.addEventListener('DOMContentLoaded', collapsibleDetails);
window.addEventListener('resize', collapsibleDetails);
